import type { Dayjs } from 'dayjs'
import type { DailyCloseProductSearch } from '@/services/inventory/dailyCloseProduct/types'
import { DATE_PARAM_FORMAT, MAX_SEARCH_DAYS, MESSAGES } from './constants'

export interface DailyCloseProductFormValues {
  shipperCode?: string
  closeDateRange?: readonly [Dayjs | null, Dayjs | null] | null
  brandName?: string
  goodsCode?: string
  barcodes?: string[]
  logisticsServiceType?: string
}

export const validateDailyCloseProductForm = (values: DailyCloseProductFormValues): string | null => {
  const [from, to] = values.closeDateRange ?? []
  if (!from || !to) return MESSAGES.closeDateRequired
  if (from.isAfter(to, 'day')) return MESSAGES.closeDateInvalidRange
  if (to.diff(from, 'day') + 1 > MAX_SEARCH_DAYS) return MESSAGES.closeDatePeriodExceeded
  if (!values.shipperCode?.trim() && !values.logisticsServiceType?.trim()) return MESSAGES.shipperOrServiceTypeRequired
  return null
}

const trimmed = (value?: string): string | undefined => value?.trim() || undefined

export const toHeadSearch = (values: DailyCloseProductFormValues): DailyCloseProductSearch => {
  const [from, to] = values.closeDateRange ?? []
  if (!from || !to) throw new Error(MESSAGES.closeDateRequired)
  const barcodes = [...new Set((values.barcodes ?? []).map((barcode) => barcode.trim()).filter(Boolean))]
  const shipperCode = trimmed(values.shipperCode)
  const brandName = trimmed(values.brandName)
  const goodsCode = trimmed(values.goodsCode)
  const logisticsServiceType = trimmed(values.logisticsServiceType)

  return {
    ...(shipperCode ? { shipperCode } : {}),
    closeDateFrom: from.format(DATE_PARAM_FORMAT),
    closeDateTo: to.format(DATE_PARAM_FORMAT),
    ...(brandName ? { brandName } : {}),
    ...(goodsCode ? { goodsCode } : {}),
    ...(barcodes.length ? { barcodes } : {}),
    ...(logisticsServiceType ? { logisticsServiceType } : {}),
  }
}
